import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateField,
  calculateShiftTips,
  saveShift,
  deleteShiftAction,
} from '../actions';
import Tips from './Tips';
import TipOut from './TipOut';
import BarTips from './BarTips';

const ShiftRecord = ({ restaurantId, employees, shift, sid, shiftID }) => {
  const dispatch = useDispatch();
  const [isLunch, setIsLunch] = useState(shift.IsLunch);
  const [employeeID, setEmployeeID] = useState(shift.EmployeeID);
  const [title, setTitle] = useState(shift.Title);
  const [netSales, setNetSales] = useState(shift.NetSales);
  const [showCalculator, setCalculator] = useState(false);
  const [beer, setBeer] = useState(shift.Beer);
  const [byBottle, setByBottle] = useState(shift.ByBottle);
  const [food, setFood] = useState(shift.Food);
  const [liquor, setLiquor] = useState(shift.Liquor);
  const [mixedCocktails, setMixCocktails] = useState(shift.MixedCocktails);
  const [naBeverage, setNaBeverage] = useState(shift.NABeverage);
  const [sake, setSake] = useState(shift.Sake);
  const [sushi, setSushi] = useState(shift.Sushi);
  const [wine, setWine] = useState(shift.Wine);
  const [serverRatio, setServerRatio] = useState(shift.ServerRatio);
  const [barRatio, setBarRatio] = useState(shift.BarRatio);
  const [expoRatio, setExpoRatio] = useState(shift.ExpoRatio);
  const [hostRatio, setHostRatio] = useState(shift.HostRatio);
  const [busserRatio, setBusserRatio] = useState(shift.BusserRatio);
  const [ccTip, setCCTip] = useState(shift.CCTip);
  const [isSaved, setSaved] = useState(shift.IsSaved);
  //const ccTipFee = shift.CCTipFee;
  const date = useSelector((state) => state.dailyShifts.date);

  const [isSavingShift, setIsSavingShift] = useState(shift.IsSavingShift);

  useEffect(() => {
    setIsLunch(shift.IsLunch);
    setEmployeeID(shift.EmployeeID);
    setTitle(shift.Title);
    setNetSales(shift.NetSales);
    setBeer(shift.Beer);
    setByBottle(shift.ByBottle);
    setFood(shift.Food);
    setLiquor(shift.Liquor);
    setMixCocktails(shift.MixedCocktails);
    setNaBeverage(shift.NABeverage);
    setSake(shift.Sake);
    setSushi(shift.Sushi);
    setWine(shift.Wine);
    setServerRatio(shift.ServerRatio);
    setBarRatio(shift.BarRatio);
    setExpoRatio(shift.ExpoRatio);
    setBusserRatio(shift.BusserRatio);
    setHostRatio(shift.HostRatio);
    setCCTip(shift.CCTip);
    setIsSavingShift(shift.IsSavingShift);
    setSaved(shift.IsSaved);
  }, [shift]);

  const divStyle = isSaved
    ? { borderStyle: 'none' }
    : { borderStyle: 'solid', borderColor: 'red' };

  return (
    <div style={divStyle}>
      <span>{sid}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span>
        <input
          type="checkbox"
          checked={isLunch}
          onChange={(e) => {
            setIsLunch(e.target.checked);
            dispatch(updateField(sid, e.target.checked, 'ISLUNCH'));
          }}
        />
        Lunch
      </span>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span>
        <label>Employee</label>
      </span>
      <select
        name="employee"
        id="employee"
        value={employeeID}
        onChange={(e) => {
          setEmployeeID(e.target.value);
          dispatch(updateField(sid, e.target.value, 'EMPLOYEEID'));
        }}
      >
        {employees.map((e, i) => (
          <option value={e.ID} key={i}>
            {e.Name}
          </option>
        ))}
      </select>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span>
        <label>Title&nbsp;&nbsp;</label>
      </span>
      {!(shift.EmployeeID === 1) ? (
        <select
          name="title"
          id="title"
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            dispatch(updateField(sid, e.target.value, 'TITLE'));
          }}
        >
          <option value=""></option>
          <option value="Server">Server</option>
          <option value="Bartender">Bartender</option>
          <option value="BarBack">BarBack</option>
          <option value="Host">Host</option>
          <option value="Expo">Expo</option>
          <option value="Busser">Busser</option>
        </select>
      ) : (
        <span>TOGO&nbsp;&nbsp;&nbsp;</span>
      )}
      {!(shift.EmployeeID === 1) &&
      (title === 'Server' || title === 'Bartender' || title === 'BarBack') ? (
        <span>
          {shift.Title === 'Server' ? (
            <span>
              <span>&nbsp;&nbsp;&nbsp;</span>
              <label>TipPool #</label>
              <input
                type="text"
                name="hours"
                style={{ width: '50px' }}
                value={serverRatio}
                onChange={(e) => setServerRatio(e.target.value)}
                onBlur={() => {
                  dispatch(updateField(sid, serverRatio, 'SERVERRATIO'));
                }}
              />
            </span>
          ) : null}
          <input
            type="checkbox"
            name="showCalculator"
            style={{ width: '30px' }}
            checked={showCalculator}
            onChange={(e) => setCalculator(!showCalculator)}
          />
          <span>
            <label>Show Calculator</label>&nbsp;&nbsp;
          </span>
          {/* {showCalculator && <span><label>Hours</label>
        <input type="text" name="hours" style={{width: '50px'}}  onBlur={() => {console.log("hours input complete")}} />
    </span> } */}
          <span>
            <label>Net Sales</label>
            <input
              type="text"
              name="netsales"
              style={{ width: '100px' }}
              value={netSales}
              onChange={(e) => setNetSales(e.target.value)}
              onBlur={() => {
                dispatch(updateField(sid, netSales, 'NETSALES'));
              }}
            />
          </span>
          {showCalculator && (
            <span>
              <span>
                <label>Beer</label>
                <input
                  type="text"
                  name="beer"
                  style={{ width: '50px' }}
                  value={beer}
                  onChange={(e) => setBeer(e.target.value)}
                  onBlur={() => {
                    dispatch(updateField(sid, beer, 'BEER'));
                  }}
                />
              </span>
              <span>
                <label>By the Bottle</label>
                <input
                  type="text"
                  name="hours"
                  style={{ width: '50px' }}
                  value={byBottle}
                  onChange={(e) => setByBottle(e.target.value)}
                  onBlur={() => {
                    dispatch(updateField(sid, byBottle, 'BYBOTTLE'));
                  }}
                />
              </span>
              <span>
                <label>Food</label>
                <input
                  type="text"
                  name="hours"
                  style={{ width: '50px' }}
                  value={food}
                  onChange={(e) => setFood(e.target.value)}
                  onBlur={() => {
                    dispatch(updateField(sid, food, 'FOOD'));
                  }}
                />
              </span>
              <span>
                <label>Liquor</label>
                <input
                  type="text"
                  name="hours"
                  style={{ width: '50px' }}
                  value={liquor}
                  onChange={(e) => setLiquor(e.target.value)}
                  onBlur={() => {
                    dispatch(updateField(sid, liquor, 'LIQUOR'));
                  }}
                />
              </span>
              <span>
                <label>Mixed Cocktails</label>
                <input
                  type="text"
                  name="hours"
                  style={{ width: '50px' }}
                  value={mixedCocktails}
                  onChange={(e) => setMixCocktails(e.target.value)}
                  onBlur={() => {
                    dispatch(
                      updateField(sid, mixedCocktails, 'MIXEDCOCKTAILS'),
                    );
                  }}
                />
              </span>
              <span>
                <label>NA Beverage</label>
                <input
                  type="text"
                  name="hours"
                  style={{ width: '50px' }}
                  value={naBeverage}
                  onChange={(e) => setNaBeverage(e.target.value)}
                  onBlur={() => {
                    dispatch(updateField(sid, naBeverage, 'NABEVERAGE'));
                  }}
                />
              </span>
              <span>
                <label>Sake</label>
                <input
                  type="text"
                  name="hours"
                  style={{ width: '50px' }}
                  value={sake}
                  onChange={(e) => setSake(e.target.value)}
                  onBlur={() => {
                    dispatch(updateField(sid, sake, 'SAKE'));
                  }}
                />
              </span>
              <span>
                <label>Sushi</label>
                <input
                  type="text"
                  name="hours"
                  style={{ width: '100px' }}
                  value={sushi}
                  onChange={(e) => setSushi(e.target.value)}
                  onBlur={() => {
                    dispatch(updateField(sid, sushi, 'SUSHI'));
                  }}
                />
              </span>
              <span>
                <label>Wine</label>
                <input
                  type="text"
                  name="hours"
                  style={{ width: '50px' }}
                  value={wine}
                  onChange={(e) => setWine(e.target.value)}
                  onBlur={() => {
                    dispatch(updateField(sid, wine, 'WINE'));
                  }}
                />
              </span>
            </span>
          )}
          {shift.Title === 'Bartender' ? (
            <span>
              <label>Bar Tip Ratio</label>
              <input
                type="text"
                name="hours"
                style={{ width: '50px' }}
                value={barRatio}
                onChange={(e) => setBarRatio(e.target.value)}
                onBlur={() => {
                  dispatch(updateField(sid, barRatio, 'BARRATIO'));
                }}
              />
            </span>
          ) : null}
          <span>
            <label>CC Tip (After withholding)</label>
            <input
              type="text"
              name="hours"
              style={{ width: '80px' }}
              value={ccTip}
              onChange={(e) => setCCTip(e.target.value)}
              onBlur={() => {
                dispatch(updateField(sid, ccTip, 'CCTIP'));
              }}
            />
          </span>
          {/* <span>
            <label>CC Fees: {ccTipFee}</label>
          </span> */}
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      ) : shift.EmployeeID === 1 ? (
        <span>
          <span>
            <label>Net Sales</label>
            <input
              type="text"
              name="netsales"
              style={{ width: '100px' }}
              value={netSales}
              onChange={(e) => setNetSales(e.target.value)}
              onBlur={() => {
                dispatch(updateField(sid, netSales, 'NETSALES'));
              }}
            />
          </span>
          <span>
            <label>CC Tip (After withholding)</label>
            <input
              type="text"
              name="hours"
              style={{ width: '80px' }}
              value={ccTip}
              onChange={(e) => setCCTip(e.target.value)}
              onBlur={() => {
                dispatch(updateField(sid, ccTip, 'CCTIP'));
              }}
            />
          </span>
          {/* <span>
            <label>CC Fees: {ccTipFee}</label>
          </span> */}
        </span>
      ) : title === 'Expo' ? (
        <span>
          <label>Expo Tip Ratio</label>
          <input
            type="text"
            name="hours"
            style={{ width: '50px' }}
            value={expoRatio}
            onChange={(e) => setExpoRatio(e.target.value)}
            onBlur={() => {
              dispatch(updateField(sid, expoRatio, 'EXPORATIO'));
            }}
          />
        </span>
      ) : title === 'Host' ? (
        <span>
          <label>Host Tip Ratio</label>
          <input
            type="text"
            name="hours"
            style={{ width: '50px' }}
            value={hostRatio}
            onChange={(e) => setHostRatio(e.target.value)}
            onBlur={() => {
              dispatch(updateField(sid, hostRatio, 'HOSTRATIO'));
            }}
          />
        </span>
      ) : title === 'Busser' ? (
        <span>
          <label>Busser Tip Ratio</label>
          <input
            type="text"
            name="hours"
            style={{ width: '50px' }}
            value={busserRatio}
            onChange={(e) => setBusserRatio(e.target.value)}
            onBlur={() => {
              dispatch(updateField(sid, busserRatio, 'BUSSERRATIO'));
            }}
          />
        </span>
      ) : null}
      <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <button
        onClick={() => {
          dispatch(calculateShiftTips(sid));
        }}
      >
        Calculate Tips
      </button>
      <br />
      {title === 'Server' ? (
        <Tips shift={shift} sid={sid} />
      ) : title === 'Bartender' || title === 'BarBack' ? (
        <BarTips shift={shift} sid={sid} />
      ) : (
        <TipOut shift={shift} sid={sid} />
      )}
      <div style={{ float: 'right' }}>
        <button
          onClick={() => {
            dispatch(saveShift(restaurantId, date, sid, shiftID));
            setIsSavingShift(true);
          }}
          disabled={isSavingShift}
        >
          {shift.ID !== undefined ? 'Update' : 'Save'}
        </button>
        <span>&nbsp;&nbsp;</span>
        {shift.ID !== undefined && (title === 'Server' || employeeID === 1) ? (
          <button
            onClick={() => {
              dispatch(deleteShiftAction(sid, shiftID));
            }}
          >
            Delete
          </button>
        ) : null}
      </div>
      <div>
        <br />
        <hr />
      </div>
    </div>
  );
};

export default ShiftRecord;
